
import restService from "@/services/restService"
import {  ITimetableSearchResult } from '@/typings/timit';
import { Vue, Watch, Component, Prop } from "vue-property-decorator";
import { TimetableStates } from "./Timetable/models/TimetableStates";

@Component
export default class OrderSearch extends Vue {
  loading: boolean = false;
  selectedTimeTable: ITimetableSearchResult | null = null;
  search = "";
  searchDebounceTimeout: any = null;
  timeTables: ITimetableSearchResult[] = [];
  isLabel = true;

  @Watch('search') async searchChanged() {
    if (this.search && this.search.length > 0) {
      await this.searchOrder();
    }
  }

  async searchOrder() {
    if (this.searchDebounceTimeout){
        clearTimeout(this.searchDebounceTimeout);
      }
      
    this.searchDebounceTimeout = setTimeout(
        async () => {
          if (this.search && this.search.length > 0) {
            const result: ITimetableSearchResult[] = await restService.timeTables.searchTimeTable(this.search);
            this.timeTables = result
          }
        }, 
        350
      )
  }

  selectTimeTable(timeTableSearchResult: ITimetableSearchResult) {
    this.$emit('timeTableSelect', timeTableSearchResult);
    this.selectedTimeTable = null;
    this.search = '';
    this.timeTables = [];
  }

  stateColor(state: number) {
    return TimetableStates.States.find(s => s.id === state).color;
  }

  stateText(state: number) {
    const stateName = TimetableStates.States.find(s => s.id === state).name;
    return this.$t(`booking.state.${stateName.toLowerCase()}.name.one`, stateName);
  }

}
